export const COLOR = {
	dark: '#393B41',
	darkMedium: '#646771',
	neutral: '#A5A8B0',
	light: '#EDEEF2',
	lightBorder: '#D7D8DE',
	primary: '#D8353B',
	white: '#fff',
	// gold: '#D3A87B',
	// darkBlured: '#44423E',
	// accessSelect: '#A5A8B0',
}
